import { ApolloClient, ApolloLink, createHttpLink, InMemoryCache } from '@apollo/client'
import { setContext } from '@apollo/client/link/context'
import { createPersistedQueryLink } from '@apollo/client/link/persisted-queries'
import { Platform } from 'react-native'
import { getAuthToken } from './authToken'

const PLATFORM_HEADER = Platform.OS === 'ios' ? 'next_app_ios' : Platform.OS === 'android' ? 'next_app_android' : 'web'

const authLink = setContext((_, { headers }) => {
  const token = getAuthToken()
  const baseHeaders = { ...headers, 'X-Platform': PLATFORM_HEADER }

  if (token) {
    return {
      headers: {
        ...baseHeaders,
        authorization: token,
      },
    }
  }

  return { headers: baseHeaders }
})

const httpLink = createHttpLink({
  uri: `${process.env.EXPO_PUBLIC_API_BASE_URL}/graphql`,
})

const persistedQueryLink = createPersistedQueryLink({
  sha256,
  useGETForHashedQueries: true,
})

async function sha256(message: string) {
  try {
    const msgBuffer = new TextEncoder().encode(message)
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer)
    const hashArray = Array.from(new Uint8Array(hashBuffer))

    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('')
    return hashHex
  } catch {
    // FIXME: double check if the empty string is a problem
    return ''
  }
}

const apolloClient = new ApolloClient({
  link: ApolloLink.from([persistedQueryLink, authLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    query: {
      fetchPolicy: 'no-cache',
    },
  },
})

export default apolloClient
